import { ReactNode } from 'react';

import { Tooltip as BaseTooltip } from '@/components/Tooltip';

interface TooltipProps {
  message: ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left';
  className?: string;
  children: ReactNode;
}

/**
 * Shim that adapts the legacy chariot-ui Tooltip API (message/position props)
 * to the current Tooltip component (title/placement props).
 */
export default function Tooltip({
  message,
  position = 'bottom',
  children,
}: TooltipProps) {
  return (
    <BaseTooltip title={message} placement={position}>
      {children}
    </BaseTooltip>
  );
}
